import { Typography } from '@mui/material'
import React from 'react'

export default function SectionTitle({ title, ...props }) {
    return (
        <Typography
            variant="h6"
            fontWeight="bold"
            gutterBottom
            {...props}
        >
            {title}
        </Typography>
    );
}
